import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletCardsDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M95 64H88.6569C87.596 64 86.5786 63.5786 85.8284 62.8284L84.1716 61.1716C83.4214 60.4214 82.404 60 81.3431 60H14.6569C13.596 60 12.5786 60.4214 11.8284 61.1716L10.1716 62.8284C9.42143 63.5786 8.40401 64 7.34315 64H1",
			stroke: "white",
			strokeOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82 36.5C86.7052 36.5 90.5 40.4003 90.5 45.1865V63.5H89.5V45.1865C89.5 40.9307 86.1314 37.5 82 37.5H14C9.86864 37.5 6.5 40.9307 6.5 45.1865V63.5H5.5V45.1865C5.5 40.4003 9.29481 36.5 14 36.5H82Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.5 32.915C93.8083 35.0517 96 38.7687 96 43V63.5C96 63.5 94 63.5 90.5 63.5V32.915Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96 84C96 90.6274 90.6274 96 84 96H12C5.37258 96 0 90.6274 0 84V83C0 89.6274 5.37258 95 12 95H84C90.6274 95 96 89.6274 96 83V84Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 63.5H1V83C1 89.0751 5.92487 94 12 94H84C90.0751 94 95 89.0751 95 83V63.5H96V83C96 89.6274 90.6274 95 84 95H12C5.37258 95 0 89.6274 0 83V63.5Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 32.915C2.19171 35.0517 0 38.7687 0 43V63.5C0 63.5 2 63.5 5.5 63.5V32.915Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.9797 76.7846C38.8756 77.6038 37.8562 78.7918 37.2589 79.6404C37.1023 79.8628 36.8085 79.9701 36.6026 79.88C36.3967 79.7898 36.3567 79.5365 36.5132 79.3141C37.1569 78.3996 38.2684 77.0942 39.5238 76.1628C40.1537 75.6956 40.8477 75.3016 41.555 75.115C42.2764 74.9247 42.9861 74.9577 43.6163 75.3112C43.8316 75.4319 43.9968 75.5981 44.0606 75.8266C44.1263 76.0614 44.0714 76.3127 43.9524 76.5485C43.732 76.9856 43.2659 77.421 42.7607 77.8173C41.7414 78.6169 40.209 79.5225 38.8054 80.352L38.735 80.3936C38.0137 80.8199 37.3245 81.2277 36.7335 81.6019C36.1353 81.9807 35.6717 82.3041 35.3853 82.5598C35.2975 82.6381 35.2394 82.6987 35.2024 82.7427C35.2213 82.7496 35.2454 82.757 35.276 82.7646C35.4114 82.798 35.625 82.8208 35.9419 82.8208C38.4594 82.8208 41.4455 81.3307 44.1666 79.841C44.467 79.6766 44.7648 79.5118 45.0581 79.3496C46.0642 78.793 47.0168 78.266 47.8377 77.8822C48.371 77.6329 48.8766 77.4303 49.3284 77.317C49.7784 77.2042 50.2191 77.1689 50.5806 77.3044C50.7855 77.3812 50.9399 77.5206 50.9946 77.7339C51.0468 77.9375 50.9948 78.1566 50.9133 78.3488C50.7562 78.7196 50.4274 79.1336 50.0722 79.5243C49.5033 80.1504 48.7252 80.8658 48.0431 81.4929C47.86 81.6613 47.6838 81.8234 47.5204 81.9756C47.3015 82.1795 47.1084 82.3632 46.9477 82.5235C46.9612 82.5183 46.975 82.513 46.9889 82.5076C47.5296 82.2985 48.3404 81.9341 49.4994 81.3695C56.9568 77.7365 61.4293 76.1369 62.7706 75.7861C63.0292 75.7185 63.2431 75.8503 63.2485 76.0805C63.2538 76.3107 63.0485 76.5522 62.7899 76.6198C61.5635 76.9407 57.1781 78.4979 49.7458 82.1187C48.5783 82.6875 47.7287 83.0709 47.1374 83.2996C46.8432 83.4133 46.5957 83.4956 46.3967 83.5414C46.2969 83.5643 46.1962 83.5812 46.1012 83.5848C46.0096 83.5882 45.8934 83.5805 45.7899 83.5291C45.6741 83.4715 45.5953 83.3688 45.5779 83.2307C45.5624 83.1069 45.6004 82.9884 45.6371 82.9051C45.7078 82.7449 45.8326 82.584 45.9476 82.4501C46.1886 82.1693 46.5548 81.8171 46.9493 81.4496C47.1289 81.2823 47.3167 81.1096 47.5075 80.9341C48.1842 80.3116 48.8994 79.6538 49.4244 79.076C49.7667 78.6994 49.9731 78.4148 50.0507 78.2317C50.0733 78.1784 50.0778 78.1501 50.0786 78.1384C50.0736 78.135 50.0645 78.1299 50.0486 78.124C49.9061 78.0705 49.683 78.0668 49.3364 78.1537C48.9915 78.2401 48.5677 78.4055 48.0655 78.6403C47.2884 79.0035 46.3907 79.5001 45.3937 80.0516C45.094 80.2174 44.7852 80.3882 44.4681 80.5618C41.7833 82.0315 38.5297 83.6898 35.6966 83.6898C35.3447 83.6898 35.0526 83.6654 34.8264 83.6096C34.6091 83.5559 34.393 83.459 34.2857 83.2643C34.1637 83.0429 34.2272 82.784 34.3538 82.5669C34.4702 82.3673 34.6501 82.1799 34.8353 82.0146C35.2102 81.6799 35.7549 81.3068 36.3593 80.9241C36.9709 80.5368 37.6786 80.1182 38.3957 79.6944L38.4013 79.691C39.8536 78.8327 41.3269 77.962 42.276 77.2175C42.7642 76.8346 43.0275 76.5498 43.1196 76.3671C43.157 76.2929 43.1542 76.2594 43.1487 76.2396C43.1414 76.2136 43.1121 76.1554 42.9906 76.0873C42.543 75.8363 42.0668 75.8189 41.5767 75.9481C41.0725 76.0811 40.5297 76.3766 39.9797 76.7846ZM50.0839 78.1432C50.0838 78.1432 50.083 78.1426 50.0821 78.1411C50.0836 78.1424 50.084 78.1431 50.0839 78.1432Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.002 14C19.6588 14 21.002 12.6569 21.002 11C21.002 9.34315 19.6588 8 18.002 8C16.3451 8 15.002 9.34315 15.002 11C15.002 12.6569 16.3451 14 18.002 14Z",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0012 8.76501C14.7988 7.6884 12.9601 7.75602 11.8401 8.91803C10.72 10.0801 10.72 11.92 11.8401 13.082C12.9601 14.244 14.7988 14.3116 16.0012 13.235",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 25L11.9816 28.9438L13.7622 25",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2359 28.9438L15.8002 25",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0499 28.9438L22.7601 25L23.9255 28.9438",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5647 25.29C18.9647 25.0587 17.9128 25.0468 17.8696 25.9181C17.8339 26.6598 18.6026 26.8987 19.0188 27.3538C19.1766 27.5257 19.2945 27.7441 19.3042 27.9765C19.3139 28.2089 19.2101 28.4403 19.0393 28.5971C18.6501 28.956 18.0447 28.8684 17.5928 28.6944",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82 19.5C86.7052 19.5 90.5 23.4003 90.5 28.1865V45.1865C90.5 43.7096 90.138 42.3173 89.5 41.0977V28.1865C89.5 23.9307 86.1314 20.5 82 20.5H14C9.86864 20.5 6.5 23.9307 6.5 28.1865V41.0977C5.86204 42.3173 5.5 43.7096 5.5 45.1865V28.1865C5.5 23.4003 9.29481 19.5 14 19.5H82Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82 2.5C86.7052 2.5 90.5 6.40025 90.5 11.1865V28.1865C90.5 26.7096 90.138 25.3173 89.5 24.0977V11.1865C89.5 6.93074 86.1314 3.5 82 3.5H14C9.86864 3.5 6.5 6.93074 6.5 11.1865V24.0977C5.86204 25.3173 5.5 26.7096 5.5 28.1865V11.1865C5.5 6.40025 9.29481 2.5 14 2.5H82Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 66,
			y: 8,
			width: 2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 69,
			y: 8,
			width: .5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70.5,
			y: 8,
			width: 1,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 72.5,
			y: 8,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.7,
			y: 8,
			width: 1.5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 76.2,
			y: 8,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 77.4,
			y: 8,
			width: .5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 78.9,
			y: 8,
			width: 2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.9,
			y: 8,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 83.1,
			y: 8,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.3,
			y: 8,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 66,
			y: 25,
			width: 2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 69,
			y: 25,
			width: .5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70.5,
			y: 25,
			width: 1,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 72.5,
			y: 25,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.7,
			y: 25,
			width: 2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 76.7,
			y: 25,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 77.9,
			y: 25,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 79.1,
			y: 25,
			width: .5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80.6,
			y: 25,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.8,
			y: 25,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 83,
			y: 25,
			width: 1.5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 66,
			y: 42,
			width: 1,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68,
			y: 42,
			width: .5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 69.5,
			y: 42,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70.7,
			y: 42,
			width: 2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.7,
			y: 42,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.9,
			y: 42,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 76.1,
			y: 42,
			width: .5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 77.6,
			y: 42,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 78.8,
			y: 42,
			width: .2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80,
			y: 42,
			width: 2,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 83,
			y: 42,
			width: 1.5,
			height: 5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.956 46.9573H17.0905C18.2184 46.9573 19.1781 46.1367 19.3538 45.0231C19.5732 43.6326 18.4984 42.375 17.0905 42.375H15.2032C14.6578 42.375 14.1931 42.7719 14.1079 43.3111L13.1825 49.179C13.1388 49.4573 13.3538 49.7088 13.6352 49.7088H14.5516C14.8491 49.7088 15.102 49.4925 15.1483 49.1987L15.4311 47.4059C15.4717 47.1477 15.6946 46.9573 15.956 46.9573Z",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1465 49.2032L14.9503 50.3594C14.9285 50.4981 15.036 50.6238 15.1769 50.6238L16.4202 50.6248C16.6459 50.6248 16.8381 50.4606 16.8733 50.2377L17.1369 48.5648H18.3325C19.4599 48.5648 20.4201 47.7443 20.5958 46.6303C20.7505 45.6491 20.2595 44.7363 19.463 44.2827L19.341 44.2156",
			stroke: "#8588D8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgWalletCardsDark;
